import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=804354d6&"
import script from "./InventoryReport.vue?vue&type=script&lang=js&"
export * from "./InventoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('804354d6')) {
      api.createRecord('804354d6', component.options)
    } else {
      api.reload('804354d6', component.options)
    }
    module.hot.accept("./InventoryReport.vue?vue&type=template&id=804354d6&", function () {
      api.rerender('804354d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/InventoryReport.vue"
export default component.exports